import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import ArrowLeft from "assets/arrow-left.svg"
import ArrowRight from "assets/arrow-right.svg"

const PrevNextLayout = (props) => {
  let { edges } = props

  // Nothing is rendered when no related posts
  if (edges.length === 1) return null
 
  const { currentPostPath } = props
  let prevPost, nextPost = null

  const currentPostIndex = edges.findIndex(
    edge => edge.node.childMarkdownRemark.frontmatter.path === currentPostPath
  )


  // 2 or more related posts
  if (edges.length > 2) {
    // Get prev and next item
    edges = edges.slice(currentPostIndex - 1, 3)

    // Sort by publish date, latest becomes first element of array
    edges.sort((a, b) => b.publishDate - a.publishDate)

    // Make older post as previous
    prevPost = edges[2].node.childMarkdownRemark.frontmatter
    nextPost = edges[0].node.childMarkdownRemark.frontmatter
  }


  // Only 1 related post
  const otherPostIndex = 1 - currentPostIndex

  // Make older post as previous
  if (edges[currentPostIndex].publishDate > edges[otherPostIndex].publishDate) {
    // Current post is more recent
    prevPost = edges[otherPostIndex].node.childMarkdownRemark.frontmatter
  } else {
    nextPost = edges[otherPostIndex].node.childMarkdownRemark.frontmatter
  }

  return (
    <>
      <div className="flex" style={{ wordBreak: 'break-word' }}>
        {prevPost ? (
          <Link to={prevPost.path} className="w-1/2 sm:p-3 p-2 flex flex-col hover:bg-orange-200 cursor-pointer">
            <p className="font-bold">
              <span className="h-4 w-4 inline-block align-middle mr-2">
                <ArrowLeft className="fill-current" />
              </span>
              <span className="sm:text-base text-sm align-middle">DON'T MISS IT</span>
            </p>
            <h5 className="sm:text-2xl text-xl mt-3">{prevPost.title}</h5>
          </Link>
        ) : <div className="w-1/2" />}

        {nextPost ? (
          <Link to={nextPost.path} className="w-1/2 sm:p-3 p-2 flex flex-col hover:bg-orange-200 cursor-pointer text-right">
            <p className="font-bold">
              <span className="sm:text-base text-sm align-middle">UP NEXT</span>
              <span className="h-4 w-4 inline-block align-middle ml-2">
                <ArrowRight className="fill-current" />
              </span>
            </p>
            <h5 className="sm:text-2xl text-xl">{nextPost.title}</h5>
          </Link>
        ) : null}
      </div>
    </>
  )
}

export default PrevNextLayout

PrevNextLayout.propTypes = {
  currentPostPath: PropTypes.string.isRequired,
};
